<template>
  <base-layout :query="require('@/graphql/Actualite.gql')" :variables="{slug: slug, pathology_slug: pathologySlug}">
    <template v-slot:title="props">
      <top :titleText="props.data.infos.edges[0].node.title" :nameText="props.data.infos.edges[0].node.title" class="blue"/>
    </template>
    <template v-slot:main-section="props">
      <article class="study u-bg--white u-align--left">
        <div class="top" v-if="props.data.infos.edges[0].node.pathology">
          <div class="infos">
            <pathology :pathology="props.data.infos.edges[0].node.pathology.name"/>
          </div>
          <PrintButton/>
        </div>

        <h3>{{props.data.infos.edges[0].node.chapo}}</h3>

        <title-simple :text="'Description'" :hasBlock="true"/>

        <RichText :dataHtml="props.data.infos.edges[0].node.body"></RichText>

        <span>Ecrit par <strong>{{props.data.infos.edges[0].node.updatedBy}}</strong> le {{parseDate(props.data.infos.edges[0].node.publicationDate)}}</span>
      </article>
    </template>

    <template v-slot:card-section="props">
      <card-study :study="props.data.studies.edges[0]" :flatButton="true"></card-study>
      <card-simple-actu :actu="props.data.infos.edges[0]" :flatButton="true"></card-simple-actu>
    </template>
  </base-layout>
</template>

<script>
  import BaseLayout from "../components/Layout/BaseLayout";
  import Pathology from "../components/Card/Granular/Pathology";
  import PrintButton from "../components/Core/PrintButton";
  import TitleSimple from "../components/Core/TitleSimple";
  import Top from "../components/Core/Top";
  import CardStudy from "../components/Card/Models/Card-study";
  import CardSimpleActu from "../components/Card/Models/Card-simple-actu";
  import RichText from "../components/Core/RichText";
  import { apolloClient } from '@/vue-apollo';
  import gql from 'graphql-tag';

  export default {
    name: "Actualite",
    components: {
      RichText,
      CardSimpleActu,
      CardStudy,
      Top, TitleSimple, PrintButton, Pathology, BaseLayout},
    data: () => {
      return {
        slug: '',
        pathologySlug: ''
      }
    },
    beforeRouteEnter(to, from, next) {
      // On appelle la requete GQL GetActu() en se basant sur le slug fourni.
      apolloClient.query({
        query: require('../graphql/Actualite.gql'),
        variables: {
          slug: to.params.slug
        }
      })
      // On recupere le node 'infos'
      .then(({ data: { infos } }) => {

        // Si aucune infos, alors page not found
        if (!infos.edges.length) {
          next({name: 'not-found'}); // j'aurais aimé conservé rediriger vers not-found sans changer l'url, mais pas trouvé
        } else {
          // sinon on continue.
          to.params.pathologySlug = infos.edges[0].node.pathology.slug
          next();
        }
      })
    },
    mounted() {
      this.pathologySlug = this.$route.params.pathologySlug
      this.slug = this.$route.params.slug
    },
    methods: {
      parseDate(date) {
        let d = date.split(' ')[0].split('-'),
                event = new Date(Date.UTC(d[0], d[1], d[2], 0, 0, 0)),
                options = {year: 'numeric', month: 'long', day: 'numeric'};

        return event.toLocaleDateString('fr-FR', options)
      },
    }
  };
</script>

<style lang="scss">
  .study {
    border: 1px solid color(border);
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.08);
    padding: rem(25px) rem(30px) rem(30px);
    font-size: rem(14px);
    line-height: rem(24px);

    .top {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding-bottom: rem(25px);
      margin-bottom: rem(30px);

      &::after {
        position: absolute;
        content: '';
        left: 0;
        bottom: 0;
        height: 1px;
        width: 100%;
        background-color: color(border);
      }

      .infos {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        @include mq($until: MD) {
          margin-bottom: rem(10px);
        }

        .tag {
          margin: 0 rem(10px) 0 0;
        }
      }
    }

    .details {
      border: 1px solid color(border);
      display: flex;
      margin-top: rem(30px);

      ul {
        padding: 0;
        margin: 0;
        list-style: none;
      }

      .label, .content {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        padding: rem(12px) rem(20px);
        white-space: nowrap;

        @include mq($until: MD) {
          padding: rem(10px);
          font-size: rem(12px);
        }
      }

      .label {
        font-weight: 700;
        -webkit-print-color-adjust: exact;
      }
    }

    h3 {
      font-size: rem(16px);
      line-height: rem(24px);
    }

    .project-leader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      .coordinates {
        display: flex;
        flex-direction: column;
      }

      .cta-round {
        margin-top: 0;

        @include mq($until: MD) {
          margin: rem(10px) 0;
        }

        &:hover {
          background-color: color(orange-hover);
        }
      }

      &.bottom {
        padding-top: rem(25px);
        margin-top: rem(30px);
        position: relative;

        &::before {
          position: absolute;
          content: '';
          left: 0;
          top: 0;
          height: 1px;
          width: 100%;
          background-color: color(border);
        }
      }
    }

    @include mq($until: MD) {
      padding: rem(20px) rem(10px);
      margin: 0 rem(10px);
    }
  }
</style>